import { Link } from "react-router-dom";
import { eur } from "@/lib/api";
import { MapPin, Home as HomeIcon, Ruler } from "lucide-react";

export default function ListingCard({ l }) {
  return (
    <Link
      to={`/annonces/${l.id}`}
      data-testid={`listing-card-${l.id}`}
      className="group block bg-white border border-navy/10 card-lift overflow-hidden"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-navy/5">
        <img src={l.images?.[0]} alt={l.title}
          width="800" height="600"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" />
        <div className={`absolute top-4 left-4 text-[10px] uppercase tracking-[0.18em] font-bold px-3 py-1.5 ${
          l.property_type === "libre" ? "bg-accent-brand text-white" : "bg-navy text-cream"
        }`}>
          {l.property_type === "libre" ? "Libre" : "Occupée"}
        </div>
        {l.is_demo && (
          <div className="absolute top-4 right-4 text-[9px] uppercase tracking-[0.18em] font-bold px-2.5 py-1.5 bg-white/95 text-navy border border-navy/20">
            Annonce de démonstration
          </div>
        )}
        {l.dpe_energy && (
          <div className={`absolute bottom-4 left-4 text-[10px] uppercase tracking-wider font-bold px-2 py-1 ${["F","G"].includes(l.dpe_energy) ? "bg-[#c0392b] text-white" : "bg-white text-navy border border-navy/20"}`}>
            DPE&nbsp;{l.dpe_energy}
          </div>
        )}
        {l.is_verified && (
          <div className="absolute top-4 left-4 text-[10px] uppercase tracking-widest font-bold px-2 py-1 bg-accent-brand text-white flex items-center gap-1" data-testid="verified-badge" title="Justificatif de propriété vérifié par notre équipe">
            <svg width="10" height="10" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
            Bien vérifié
          </div>
        )}
      </div>
      <div className="p-6">
        <h3 className="font-serif text-xl text-navy leading-tight mb-2 group-hover:text-accent-brand transition-colors">
          {l.title}
        </h3>
        <div className="flex items-center gap-4 text-xs text-navy/60 mb-4">
          <span className="flex items-center gap-1"><MapPin size={13} />{l.city}</span>
          <span className="flex items-center gap-1"><Ruler size={13} />{l.surface} m²</span>
          <span className="flex items-center gap-1"><HomeIcon size={13} />{l.rooms} p.</span>
        </div>
        <div className="grid grid-cols-3 gap-2 pt-4 border-t border-navy/10">
          <div>
            <div className="text-[10px] uppercase tracking-wider text-navy/50 mb-0.5">Bouquet</div>
            <div className="font-serif text-base text-accent-brand font-semibold">{eur(l.bouquet)}</div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-wider text-navy/50 mb-0.5">Mensualité</div>
            <div className="font-serif text-base text-navy font-semibold">{eur(l.monthly_payment)}</div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-wider text-navy/50 mb-0.5">Durée</div>
            <div className="font-serif text-base text-navy font-semibold">{l.duration_years} ans</div>
          </div>
        </div>
      </div>
    </Link>
  );
}
